"use client";

import AppImage from "@/components/ui/AppImage";
import { motion } from "framer-motion";



const team = [
{
  name: "Lukas Brandt",
  role: "Co-Founder & CEO",
  bio: "Former ecommerce operator. Relocated to Shenzhen in 2022 after spending 5 years running DTC brands and fighting with unreliable 3PLs.",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a79b8e72-1763295320816.png",
  alt: "Lukas Brandt, co-founder of Helium Fulfilment, professional headshot",
  flag: "🇩🇪",
  lang: "EN / DE"
},
{
  name: "Sophie Kalder",
  role: "Head of Client Success",
  bio: "Logistics background with 8 years in supply chain management across Europe and Asia. Fluent in three languages and obsessed with response time.",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f5ce78df-1768271415850.png",
  alt: "Sophie Kalder, Head of Client Success at Helium Fulfilment",
  flag: "🇳🇱",
  lang: "EN / NL / DE"
},
{
  name: "Wei Chen",
  role: "Head of Operations",
  bio: "20 years in Shenzhen logistics. Built the warehouse infrastructure and carrier relationships that power Helium\'s speed advantage.",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1038f07ff-1763294921246.png",
  alt: "Wei Chen, Head of Operations at Helium Fulfilment in Shenzhen",
  flag: "🇨🇳",
  lang: "ZH / EN"
},
{
  name: "Marta Kowalski",
  role: "Head of Technology",
  bio: "Built the Helium platform from scratch. Previously at a Berlin logistics SaaS. Obsessed with automation, integrations, and zero-latency systems.",
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10819701d-1767194315681.png",
  alt: "Marta Kowalski, Head of Technology at Helium Fulfilment",
  flag: "🇵🇱",
  lang: "EN / PL"
}];


export default function TeamSection() {
  const staggerContainer = {
    initial: {},
    whileInView: {
      transition: {
        staggerChildren: 0.12
      }
    },
    viewport: { once: true, margin: "-80px" }
  };

  const cardVariant = {
    initial: { opacity: 0, y: 40, scale: 0.95 },
    whileInView: { opacity: 1, y: 0, scale: 1 },
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] }
  };

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-dark-bg border-t border-border-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-10 sm:mb-12 lg:mb-14"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}>
          
          <span className="section-label mb-3 sm:mb-4 inline-flex text-xs sm:text-sm">The Team</span>
          <h2
            className="font-heading font-extrabold text-text-primary mb-3 sm:mb-4 px-4"
            style={{ fontSize: "clamp(26px, 4.5vw, 44px)", letterSpacing: "-0.02em" }}>
            
            European-led. Shenzhen-based.
          </h2>
          <p className="text-sm sm:text-base text-text-secondary max-w-2xl mx-auto px-4">
            A multicultural team with deep logistics expertise and European operational standards.
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8"
          variants={staggerContainer}
          initial="initial"
          whileInView="whileInView"
          viewport={{ once: true, margin: "-80px" }}
        >
          {team?.map((member, index) => (
            <motion.div
              key={member?.name}
              className="glass-card rounded-3xl sm:rounded-4xl p-6 sm:p-8 text-center border border-glass-border backdrop-blur-xl transition-all duration-500 hover:shadow-glass-hover hover:-translate-y-1"
              variants={cardVariant}
            >
              <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full overflow-hidden mx-auto mb-4 sm:mb-5 border-2 border-accent-primary/20">
                <AppImage
                  src={member?.avatar}
                  alt={member?.alt}
                  width={96}
                  height={96}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="mb-2 sm:mb-3">
                <h3 className="text-lg sm:text-xl font-extrabold font-heading text-text-primary mb-1">
                  {member?.name}
                </h3>
                <p className="text-xs sm:text-sm text-accent-primary font-semibold">
                  {member?.role}
                </p>
              </div>
              <p className="text-xs sm:text-sm text-text-secondary leading-relaxed mb-3 sm:mb-4">
                {member?.bio}
              </p>
              <div className="pt-3 sm:pt-4 border-t border-divider">
                <p className="text-xs text-text-secondary">
                  <span className="mr-2">{member?.flag}</span>
                  {member?.lang}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}